// @ts-check
import sunglassesDudesImg from 'images/characters/sunglasses-dudes.svg';
import Icon from 'components/base/Icon';
import { reportedMetricsModalOptions } from 'modals/modal-options-factory';
import { useDispatch } from 'react-redux';
import { toggleModal } from 'state/callers';
import {
  StyledDescription,
  StyledEmptyStateReportedWidget,
  StyledTitle
} from './EmptyStateReportedWidget.style';
import { LBButton } from '@linearb/buzz';

const EmptyStateReportedWidget = ({ widget, onSave }) => {
  const dispatch = useDispatch();
  return (
    <StyledEmptyStateReportedWidget>
      <img src={sunglassesDudesImg} alt='' />
      <StyledTitle>Nothing to show yet</StyledTitle>
      <StyledDescription>
        <b>Click the setting button </b> to set up this metric
      </StyledDescription>
      <LBButton
        variant='outline'
        size='icon'
        onClick={() => {
          toggleModal(
            reportedMetricsModalOptions({
              widget,
              onChange: onSave
            })
          )(dispatch);
        }}
      >
        <Icon size='normal' name='settings' alpha={0.7} />
      </LBButton>
    </StyledEmptyStateReportedWidget>
  );
};
export default EmptyStateReportedWidget;
